import styled from 'styled-components'

export const Select = styled.select`
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='2'%3e%3cpath d='M4 8 L12 16 L20 8'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 4px center;
  background-color: transparent;
  border: 1px solid #073c7a;
  border-radius: 2px;
  color: #073c7a;
  font-size: 14px;
  min-width: 150px;
  padding: 0px 32px 0px 8px;
  height: 32px;
`
Select.displayName = 'Select'
